import { render, staticRenderFns } from "./ExportFileModal.vue?vue&type=template&id=2b1f7121"
import script from "./ExportFileModal.vue?vue&type=script&lang=js"
export * from "./ExportFileModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports